import { render, staticRenderFns } from "./PaymentHelp.vue?vue&type=template&id=4d6b35d0&scoped=true&"
import script from "./PaymentHelp.vue?vue&type=script&lang=js&"
export * from "./PaymentHelp.vue?vue&type=script&lang=js&"
import style0 from "./PaymentHelp.vue?vue&type=style&index=0&id=4d6b35d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6b35d0",
  null
  
)

export default component.exports